import React, {Component} from 'react'

import DaySelector from './components/DaySelector'
import FligthsTable from './components/FligthsTable'

//styles
import './App.less'


class App extends Component {
	
	componentWillMount() {
		this.setState({day:null})
	}	

	daySelect(day){
		this.setState({day:day})
	}

	render() {
		return (
			<div className="App">
				<header>
					<div className="destination">
						Moscow <i>✈</i> St. Petersburg
					</div>
					<p>Step 1: select flight</p>
				</header>
				<section>
					<DaySelector onDaySelect={this.daySelect.bind(this)} />
					<FligthsTable day={this.state.day} />
				</section>
			</div>
		)
	}
}

export default App


// WEBPACK FOOTER //
// ./src/App.js